export enum IncidentReviewStatus {  
    Pending = 1,
    Approved = 2,
    Abandoned = 3,
    Unapproved = 4,


    Unknown = 99
}